import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { UserManagementService } from "../user-management.service";
import { SignupComponent } from "../signup/signup.component";
import { environment } from "src/environments/environment";
import { interval, Subscription } from "rxjs";
import { ModalService } from "src/app/service/modal.service";
import * as CryptoJS from "crypto-js";
import { SessionService } from "src/app/session.service";
import { ForgotpassComponent } from "../forgotpass/forgotpass.component";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.css"],
    standalone: false
})
export class LoginComponent implements OnInit {
  private storage = environment.storage;
  loginForm: any;
  loading = 0;
  btnDisabled: any;
  lfcount: any;
  timeLeft: number = 60;
  subscription: Subscription;
  isLogin: boolean;
  errorMessage: string = "";
  constructor(
    private fb: FormBuilder, 
    private messageService: MessageService,
    // private authService: SocialAuthService,
    private sessionService: SessionService,
    private mservice: ModalService,
    private router: Router,
    private userService: UserManagementService,
  ) {}

  ngOnInit(): void {
    this.btnDisabled = 0;
    this.isLogin = true;
    const str = this.storage.getItem("falied-login-count");
    if (str) {
      const num = parseInt(str, 10);
      if (num > 5) {
        this.btnDisabled = 1;
        this.timeLeft = 60;
        const source = interval(1000);
        this.subscription = source.subscribe(() => {
          this.timeLeft--;

          if (this.timeLeft === 0) {
            this.subscription.unsubscribe();
          }
        });
        setTimeout(() => {
          this.btnDisabled = 0;
          const lfc = "0";
          this.storage.setItem("falied-login-count", lfc);
        }, 60000);
      } else {
        this.btnDisabled = 0;
      }
    }
    this.initForm();
  }

  requestAccess(): void {
    const targetRole = '12'; // Example target role
    this.userService.requestTemporaryAccess(targetRole)
      .then((response) => {
        console.log('Temporary access granted:', response);
      })
      .catch((error) => {
        console.error('Error requesting temporary access:', error);
      });
  }

  initForm() {
    // Add custom validation to the password field here
    this.loginForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", [Validators.required, this.customPasswordValidator]],
    });
  }

  customPasswordValidator(control: any) {
    const forbiddenPattern =
      /aYlNlfdX0'XOR\(if\(now\(\)=sysdate\(\),sleep\(6\),0\)\)XOR'Z/;
    if (control.value && forbiddenPattern.test(control.value)) {
      return { forbiddenPassword: { value: control.value } };
    }
    return null;
  }

  onLogin() {
    this.errorMessage = "";

    let pas = this.loginForm.get("password").value;
    if (!pas) {
      this.errorMessage = "Password is required.";
      return;
    }

    this.loginForm.get("password").setValue("");
    const hash = CryptoJS.MD5(pas);
    const PasswordHash = hash.toString();
    const SECRET_KEY = "purbi123";
    const hashedPassword = CryptoJS.AES.encrypt(pas, SECRET_KEY).toString();
    this.loginForm.get("password").setValue(hashedPassword);
    const request = Object.assign({ purpose: "login" }, this.loginForm.value);
    this.loginForm.get("password").setValue("");
    this.loginForm.get("email").setValue("");

    this.userService
      .login(request)
      .then((response: any) => {
        console.log('Login successful:', response);
        if (response && response.status == 1 && response.user) {
          this.loading++;
          const siteInfo = JSON.parse(JSON.stringify(response.user.allsites));
          delete response.user.allsites;
          this.userService.addUserDetail(response.user);
          this.userService.addSiteDetails(siteInfo);
          this.sessionService.resetSessionTimeout();
          if (response.user.role == 16) {
            console.log('Redirecting to UserManagementSitesComponent...');
            this.router.navigate(["/user-management-sites"]).then(() => {
              console.log('Navigation to UserManagementSitesComponent successful.');
            }); // Redirect to UserManagementSitesComponent
          } else if (response.user.role == 13) {
            this.router.navigate(["reportlibrary/editreport/process"]);
          } else {
            this.router.navigate(["/"]).then(() => {
              window.location.reload();
            });
          }
        } else {
          this.loginForm.get("password").setValue("");
          // Check for message field first, then msg field, then default message
          this.errorMessage = response.message || response.msg || "Invalid login credentials.";
          
          // Only access response.data if it exists
          if (response.data && response.data.cntLoginAttempt) {
            const loginFailCount = response.data.cntLoginAttempt;
            this.storage.setItem("falied-login-count", loginFailCount);
            if (loginFailCount) {
              const num = parseInt(loginFailCount, 10);
              if (num > 5) {
                this.btnDisabled = 1;
                this.timeLeft = 60000;
                const source = interval(100000);
                this.subscription = source.subscribe(() => {
                  this.timeLeft--;

                  if (this.timeLeft === 0) {
                    this.subscription.unsubscribe();
                  }
                });
                setTimeout(() => {
                  this.btnDisabled = 0;
                  const lfc = "0";
                  this.storage.setItem("falied-login-count", lfc);
                }, 6000000);
              } else {
                this.btnDisabled = 0;
              }
            }
          }
        }
      })
      .catch((error) => {
        this.loginForm.get("password").setValue("");
        this.errorMessage =
          "Unable to login. Please check your username or password and try again.";
      });
  }

  onClickLogin(event) {
    if (event == "login") {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  }

  sendToastMessage(messageType, title, message) {
    this.messageService.add({
      severity: messageType,
      summary: message,
      detail: title,
    });
  }

  signUp(): void {
    this.openSignupModal();
  }

  forgot(): void {
    this.openForgotModal();
  }

  private openSignupModal() {
    const modalRef = this.mservice.open(SignupComponent, {
      options: {
        backdrop: false,
        keyboard: true,
      },
    });
  }

  private openForgotModal() {
    const modalRef = this.mservice.open(ForgotpassComponent, {
      options: {
        backdrop: false,
        keyboard: true,
      },
    });
  }
}
